/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AttendanceType = {
    Present: 'Present',
    Absent: 'Absent'
} as const;
export type AttendanceType = typeof AttendanceType[keyof typeof AttendanceType];


export function instanceOfAttendanceType(value: any): boolean {
    for (const key in AttendanceType) {
        if (Object.prototype.hasOwnProperty.call(AttendanceType, key)) {
            if (AttendanceType[key as keyof typeof AttendanceType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AttendanceTypeFromJSON(json: any): AttendanceType {
    return AttendanceTypeFromJSONTyped(json, false);
}

export function AttendanceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttendanceType {
    return json as AttendanceType;
}

export function AttendanceTypeToJSON(value?: AttendanceType | null): any {
    return value as any;
}

export function AttendanceTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): AttendanceType {
    return value as AttendanceType;
}

